import { post, fetch, Del, put } from "@/ask/axios";
export default {
  props:{
      IsWhat:{
          type:String
      }
  },
  data (){
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },

      //tab选项卡
      activeName: 'first',
      inFore:false, //报关时间是否在到达时间前

      //订单详情
      waybillNO:'',
      // 费用信息总和
      CostSum:null,
      CostSumWb:null,
      //提单总和信息
      StorageBillTotal:'',
      CostTotal:'', //入仓总计
      
      //入仓求和信息
      CostVolumeTotal:'',
      CostWeightTotal:'', 
      CostQuanlityTotal:'',
      CostVolumeWeightTotal:'',

      //提单求和
      StorageQuanlitySum: '',
      StorageVolumeSum: '',

      //费用求和
      UnpaySum:null,
      UnpaySumWb:null,
      
      isCol:false,
      Remarks:'',//分享订单备注
      RemarksMesg:'',//分享订单备注
      EmailId:'',//分享邮箱
      EmailMesg:'邮箱分享',


      // 各种接口数据
      OrderDetail:'', //订单信息
      OrderCost: '',//费用信息
      StorageBillInfo:'', //入仓 --提单信息
      CostInfo:'', //入仓 - 入仓信息
      OrderContact:'', //收发联系人
      airLineInfo:'', //航班信息
      OrderEnclosure:'', //订单附件
      OrderTDEnclosure:'', //订单提单附件
      OrderInfoTrack:'', //轨迹
      CargoDoc:'', //随机文件
      DeliverContact:'' , ///派送联系人信息
      // 遮罩层
      showModal: false,
      addSendBox:false,
      

      PackageUnit: '',
      AmountName:'',//整个账单的币种符合

      //查看详情
      seeDetailFlag1:false,
      seeDetailFlag:false,
      //轨迹图
      StartAddrInfo: '', //起运地
      WarehouseInfo: '', //仓库信息
      StartAirInfo: '', //起飞机场
      TransAirInfos: '',//货物中转
      DestAirInfo: '',//目的机场
      DestAddrInfo: '',//目的地
      
      //展示轨迹图的Flag 控制器
      StartAddrFlag: false, //起运地
      WarehouseFlag: false, //仓库信息
      StartAirFlag: false, //起飞机场
      TransAirFlag: false,//货物中转
      DestAirFlag: false,//目的机场
      DestAddrFlag: false,//目的地

      DestinationFlag: false, //目的地显示 只要目的地为机场才显示
      
      airShareBox:false, //弹框分享
      // 参考号
      IsCustomerID:'',
      CustomerIDUp:'',
    }

  },
  watch: {
    $route(to,from){
      this.waybillNO = this.$route.query.WaybillNO
      this.GetOrderDetail()
    }
  },
  computed: {
    // 服务类型
    getOrderServiceType(){
      switch (this.OrderDetail.OrderServiceType) {
        case 1:
          return 'Door to Door'
        case 2:
          return 'Door to Terminal'
        case 3:
          return 'Terminal to Terminal'
        case 4:
          return 'Terminal to Door'
      }
    },
  },
  created() {
    this.waybillNO = this.$route.query.WaybillNO
    this.firstEnter()
    
  },
  mounted() {
    this.GetOrderDetail()  //获取订单详情
  },
  methods: {
    aggregate() {
      this.getCostInfo() //获取费用信息
      this.getAirOrderContactInfo() //用户联系人信息
      this.getStorageBillInfo() //获取提单信息
      this.getStorageInfo() //入仓信息
      this.getFlightInfo() // 航班信息
      this.ExpOderEnclosure() //附件信息
      this.AirOrderInfoTrack() //轨迹信息
      this.GetCargoDoc() //随机文件
      this.GetDeliverOrder()
     
    },
    firstEnter() {
      //展示轨迹图的Flag 控制器
      this.StartAddrFlag= true //起运地
      this.WarehouseFlag= true //仓库信息
      this.StartAirFlag= true //起飞机场
      this.TransAirFlag= true//货物中转
      this.DestAirFlag= true//目的机场
      this.DestAddrFlag= true//目的地
    },
    CustomerIDUpdate(id){
      if(this.IsCustomerID){
        this.IsCustomerID=false;
      }else{
      this.IsCustomerID=true;
      this.CustomerIDUp=id;
      }
    },
    orderStatus(val) {
      // 新的：0=未确认，1=已确认，2=已接单   ，3= 已订舱 ，4= 转运中 ， 5= 已完成 ，
      //6= 已退件 ，7= 已撤销 ，8： 派送中 
        if(val=='未确认') return 'Confirming'
        if(val=='已确认') return 'Confirmed'
        if(val=='已接单') return 'Received'
        if(val=='已订舱') return 'Reserved'
        if(val=='转运中') return 'Delivering'
        if(val=='已完成') return 'Completed'
        if(val=='已退件') return 'Returned'
        if(val=='已撤销') return 'Canceled'
        if(val=='派送中') return 'Distribute'
      },
    // 操作 -------------
    //导出订单
    ExportBill() {
      let that = this;
      this.api.param ={
        waybillNO:that.waybillNO
      }
      this.api.url = this.$api03+"/api/TradeCustomer/AirShareVisitors/BillCostReportQuery"
      post(this.api.url,this.api.param).then(function (res) {
          if(res.IsOK==true){
            loading.close();
            // 创建隐藏的可下载链接
            var eleLink = document.createElement('a');
            eleLink.download = "";
            eleLink.style.display = 'none';
            eleLink.href = that.$api03+'/'+res.Results,'_blank';
            // 触发点击
            document.body.appendChild(eleLink);
            eleLink.click();
            // 然后移除
            document.body.removeChild(eleLink);
         } else {
          that.$alert( '导入失败','提示',  {
          customClass:'custom-message-box', //自定义添加Class
          confirmButtonText: '确定',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
          center: true
          }).then(() => {
          }).catch(() => {
          });
         }
        }
      );
    },
    //下载附件信息
    DownloadAttachments(id,name){
      let that = this;
        that.$confirm("是否下载附件！", "提示", {
          customClass: "custom-message-box", //自定义添加Class
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
          closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
          center: true
        })
        .then(() => {
          let mb=this.myBrowser();
            if('IE'==mb){
              this.expName( id,name)
            }else{
              this.expFile( id,name)
            }
        })
        .catch(() => {});
      return false;
    },
    //判断 ie10-ie11 不再支持document.all判断
    myBrowser(){
      if(!!window.ActiveXObject || "ActiveXObject"in window){
        return "IE";
      }
    },
    //下载文件  不兼容ie
    expFile(url, fileName) {
      // 创建隐藏的可下载链接
      var eleLink = document.createElement('a');
      eleLink.target = "_blank";
      eleLink.download = fileName;
      eleLink.style.display = 'none';
      eleLink.href = url;
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
    },
    //导出订单下载文件名修改并保存 兼容ie10+ 和 谷歌（Chrome）
    expName(url, filename){
      this.getBlob(url).then(blob => {
        this.saveAs(blob, filename);
      });
    },
    getBlob(url){
      return new Promise(resolve => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };
        xhr.send();
      });
    },
    saveAs(blob, filename){
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
    },
    //参考号
    UpdataRefNO(id){
      this.$confirm("是否保存参考号", "提示", {
        customClass: "custom-message-box", //自定义添加Class
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
        closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
        center: true
      })
        .then(() => {
          this.SaveRefNOApi(id);
        })
        .catch(() => {
        });
      return false;
    },
    //参考号Api ----暂时有问题

    //取消保存参考号
    cancel(){
      this.IsCustomerID=false;
    },
    //显示隐藏轨迹图
    showTrajectory(flag){
      switch (flag) {
        case 1:
          this.StartAddrFlag = !this.StartAddrFlag
          break;
        case 2:
          this.WarehouseFlag = !this.WarehouseFlag
          break;
        case 3:
          this.StartAirFlag = !this.StartAirFlag
          break;
        case 4:
          this.TransAirFlag = !this.TransAirFlag
        break;
        case 5:
          this.DestAirFlag = !this.DestAirFlag
        break;
        case 6:
          this.DestAddrFlag = !this.DestAddrFlag
        break;
        default:
          break;
      }
    },

    ///---------------计算----------
    //求和计算cost金额
    getSumPrice() {
      let Sum = 0
      let sumWb=0
      this.OrderCost.forEach(element => {
        if(element.Currency==1){
          Sum += element.Amount
        }
        if(element.Currency==2){
          sumWb += element.ConvertAmount
        }
        });
      this.CostSum = Sum
      this.CostSumWb = sumWb
    },
    //求和计算入仓Storage金额
    getCostSum(Type) {
      let Sum = 0
      this.CostInfo.AirOrderInstoreGVList.forEach(element => {
        Sum += element[Type]
      });
      let CostType = `Cost${Type}Total`
      this[CostType] = Sum
    },
        /**
     * @param {String} Type  传入计算的类型名称
     * 计算体积和
     */
    StorageTotal(Type) {
      //通过long wide high 求 体积
      if(Type == 'getVolume') {
        this.StorageBillInfo.AirOrderInfoBillGVList.forEach(element => {
          element.Volume =Number((element.Long*element.High*element.Wide) * element.Quanlity) / 1000000
        });
        return
      }
      let Sum = 0 
      this.StorageBillInfo.AirOrderInfoBillGVList.forEach(element => {
        Sum += Number(element[Type]) 
      });
      let SumType = `Storage${Type}Sum` //eg: StorageQuanlitySum ,在data定义一个StorageQuanlitySum
      this[SumType] = Sum
    },
    /**
     * 
     */
    //计算未支付的总和
    UnpaySumFn (Data){
      Data = Data.filter((element)=>{
        return element.BillStatus!= 1
      })
      let Sum = 0 
      let sumWb=0
      Data.forEach(element => {
        if( element.Currency==1){
           Sum += Number(element.Amount) 
        }else if(element.Currency==2){
          sumWb += Number(element.ConvertAmount) 
        }
        
        
      });
      this.UnpaySum = Sum
      this.UnpaySumWb = sumWb
    },

    // +++++++++++接口队列++++渲染数据++++++
    // -------------- 获取信息-------
    //随机文件
    GetCargoDoc() {
      let that = this;
      that.api.url=that.$api03+"/api/TradeCustomer/AirShareVisitors/CargoDocQuery";
      that.api.param = {
        WaybillNO:that.waybillNO,
      }
      post(that.api.url,that.api.param).then((res)=>{
        if(res.IsOK){
          that.CargoDoc = res.Results
        } else {
        }
      })
    },
    //派送信息
    GetDeliverOrder() {
      let that = this;
      that.api.url=that.$api03+"/api/TradeCustomer/AirShareVisitors/DeliverQuery";
      that.api.param = {
        WaybillNO:that.waybillNO,
      }
      post(that.api.url,that.api.param).then((res)=>{
        if(res.IsOK){
          that.DeliverContact = res.Results.DeliverContact
        } else {
        }
      })
    },
    
    //获取订单详情
    GetOrderDetail() {
      let that = this;
      this.waybillNO = this.$route.query.WaybillNO
      that.api.url=that.$api03+"/api/TradeCustomer/AirShareVisitors/GetOrderDetail";
      that.api.param = {
        Id:this.waybillNO,
      }
      fetch(that.api.url,that.api.param).then((res)=>{
        if(res.IsOK){
          that.OrderDetail = res.Results
          //that.getAmountName(that.OrderDetail.Currency)
          that.showDestination()
          this.aggregate()  //信息集合
        } else {
        }
      })
    },
    // 获取币种符号
    getAmountName(Currency) {
      switch (Currency) {
        case 1:
          this.AmountName = '￥'       
          return 
        case 2:
          this.AmountName = '$'       
          return 
        case 3:
          this.AmountName = 'HK$'       
          return 
        case 4:
          this.AmountName = '€'      
          return 
      }
    },
    //显示轨迹的目的地
    showDestination() {
      if(this.OrderDetail.OrderServiceType == 2 || this.OrderDetail.OrderServiceType == 3){
        this.DestinationFlag = false // 不显示
      } else {
        this.DestinationFlag = true
      }
    },
    //获取费用信息
    getCostInfo(){
      let that=this;
      this.api.param={
        'waybillNO':that.waybillNO
      }
      this.api.url=this.$api03+"/api/TradeCustomer/AirShareVisitors/QueryBill";
      post(this.api.url,this.api.param).then(function (res) {
        if(res.Results){
          that.OrderCost= res.Results
          // 未支付总计
          //计算总价
          that.getSurePeice() //筛选出正负价格
          that.getSumPrice()
          that.UnpaySumFn(that.OrderCost)
        }
      })
    },
    getSurePeice() {
      this.OrderCost.forEach(item => {
        if(item.Direction){
         item.Amount = -item.Amount
        }
      });
    },
    //联系人信息
    getAirOrderContactInfo(){
      let that = this;
      this.api.param={
        waybillNO:that.waybillNO
      }
      this.api.url=this.$api03+"/api/TradeCustomer/AirShareVisitors/GetContactInfo";
      post(this.api.url,this.api.param).then(function (res) {
        if(res.IsOK){
          that.OrderContact = res.Results
        }
      })
    },
    //入仓信息
    getStorageInfo(){
      let that = this;
      this.api.param={
        'waybillNO':that.waybillNO
      }
      this.api.url=this.$api03+"/api/TradeCustomer/AirShareVisitors/GetInsrore";
      post(this.api.url,this.api.param).then(function (res) {
        //console.log('第一步..........'+JSON.stringify(res))
        if(res.Results){
          that.CostInfo = res.Results
          that.CostTotal = that.CostInfo.AirOrderInstore
          that.getCostSum('Volume')//求和计算入仓Storage金额
          that.getCostSum('Weight')//求和计算入仓Storage金额
          that.getCostSum('Quanlity')//求和计算入仓Storage金额
          that.getCostSum('VolumeWeight')//求和计算入仓Storage金额
        }
      })
    },
    //入仓信息-提单信息
    getStorageBillInfo(){
      let that = this;
      this.api.param={
        waybillNO:that.waybillNO
      }
      this.api.url=this.$api03+"/api/TradeCustomer/AirShareVisitors/GetAirLading";
      post(this.api.url,this.api.param).then(function (res) {
          if(res.Results){
            //提单信息
            
            that.StorageBillInfo=res.Results;//材积信息
            that.StorageBillTotal = that.StorageBillInfo.AirOrderInfoBill      
            //计算体积和 件数和   计算体积  
            that.StorageTotal('getVolume') //注意Volume不能放下面
            that.StorageTotal('Quanlity') 
            that.StorageTotal('Volume') 
          }
      })
    },
    //航班信息
    getFlightInfo(){
      let that = this;
      this.api.param ={
        waybillNO:that.waybillNO,
      }
      this.api.url = this.$api03+"/api/TradeCustomer/AirShareVisitors/GetAirBooking"
      post(this.api.url,this.api.param).then(function (res) {
          that.airLineInfo=res.Results;
        }
      );
    },
    //订单提单附件信息
    ExpOrderTDEnclosure(){
      let that = this;
      that.api.param={
        waybillNO:that.waybillNO
      }
      that.api.url=that.$api03+"/api/TradeCustomer/AirShareVisitors/TDQuery";
        post(that.api.url,that.api.param).then(function (res) {
            if(res.IsOK==true){
              that.OrderTDEnclosure=res.Results  //订单附件信息
              // 未支付总计
              if(!that.OrderCost.length || that.UnpaySum>0){
                // 筛选出供应商的信息
                that.OrderTDEnclosure = that.OrderTDEnclosure.filter((element)=>{
                  return element.UploadType!= 2
                })
              }
              that.OrderEnclosure.push(...that.OrderTDEnclosure) //全部订单信息
              // 进行时间排序
              that.OrderEnclosure.sort(function(a,b){
                return Date.parse(a.CreateTime) - Date.parse(b.CreateTime)
              })
              
              //console.log('ss'+JSON.stringify(res));
            }
        })
    },
    ///我的消息
    SrcFrom(id){
      var imtoken = $.cookie('IMEn-TOKEN');
      return  this.$apiIMEn+'chats/Worklist?orderid='+id+'&trackid='+imtoken+'&lan=English';
    },
    ExpOderEnclosure(){
      let that = this;
      that.api.param={
        waybillNO:that.waybillNO
      }
      that.api.url=that.$api03+"/api/TradeCustomer/AirShareVisitors/AttachQuery";
        post(that.api.url,that.api.param).then(function (res) {
            if(res.IsOK==true){
              that.OrderEnclosure=res.Results  //订单附件信息
              that.ExpOrderTDEnclosure() //订单提单附件
                //console.log('ss'+JSON.stringify(res));
            }
        })
    },
    //轨迹接口
    AirOrderInfoTrack(){
      let that = this;
      that.api.param={
        waybillNO:that.waybillNO,
        Origin:50
      }
      that.api.url=that.$api03+"/api/TradeCustomer/AirShareVisitors/GetTranckNodeInfo";
        post(that.api.url,that.api.param).then( (res)=> {
            if(res.IsOK==true){
              this.OrderInfoTrack=res.Results
              this.StartAddrInfo = this.OrderInfoTrack.StartAddrInfo //起运地
              this.WarehouseInfo = this.OrderInfoTrack.WarehouseInfo //仓库信息
              this.StartAirInfo = this.OrderInfoTrack.StartAirInfo //起飞机场
              this.TransAirInfos = this.OrderInfoTrack.TransAirInfos//货物中转
              this.DestAirInfo = this.OrderInfoTrack.DestAirInfo//目的机场
              this.DestAddrInfo = this.OrderInfoTrack.DestAddrInfo//目的地 
              if(this.StartAirInfo.ArriveTime && this.WarehouseInfo.CustomsTime) {
                if(new Date(this.StartAirInfo.ArriveTime).getTime() >  new Date(this.WarehouseInfo.CustomsTime).getTime()) {
                  this.inFore = true
                } else {
                  this.inFore = false
                }
              }
            }
        })
    },
  }
}


// WEBPACK FOOTER //
// ./src/components/receiptPage/exp/receiptAirDetails.js